import { StaticImageData } from 'next/image';
import catchPositionImg from '../assets/image_catches.png';
import spotPredictionImg from '../assets/image_hotspot.png';
import waypointsImg from '../assets/image_waypoints.png';

export interface IModalContent {
  headline: string;
  description: string;
  image: StaticImageData;
}

export const spotPrediction: IModalContent = {
  headline: 'Fishbrain is better in the app',
  description: 'Our exclusive algorithm finds unexplored spots with the highest chance of a catch.',
  image: spotPredictionImg,
};
export const catchPosition: IModalContent = {
  headline: 'Fishbrain is better in the app',
  description:
    'Get the exact locations of over 14 million verified catches, including intel on conditions and species.',
  image: catchPositionImg,
};
export const waypoint: IModalContent = {
  headline: 'Fishbrain is better in the app',
  description:
    'Build your own fishing maps with everything you need to remember about your top fishing spots.',
  image: waypointsImg,
};
